import React from 'react';
import type { MenuItemProps } from './menu-item.types';
import styles from './menu-item.module.css';
import Icon from '../../atoms/icon';
import { useMenuItemStyles } from './use-menu-item-styles';

export const MenuItem: React.FC<MenuItemProps> = ({
    label,
    labelProps,
    leadingIconProps,
    trailingIconProps,
    trailingAction,
    containerClassName,
    leftContainerClassName,
    rightContainerClassName,
}) => {
    const {
        containerClassNames,
        leftContainerClassNames,
        leadingIconClassNames,
        rightContainerClassNames,
        trailingIconClassNames,
        labelContent,
    } = useMenuItemStyles({
        label,
        labelProps,
        leadingIconProps,
        trailingIconProps,
        containerClassName,
        leftContainerClassName,
        rightContainerClassName,
    });

    return (
        <div className={containerClassNames}>
            <div className={leftContainerClassNames}>
                <Icon showIf={!!leadingIconProps} {...leadingIconProps} className={leadingIconClassNames} />
                {labelContent}
            </div>

            <div className={rightContainerClassNames}>
                <Icon showIf={!!trailingIconProps} {...trailingIconProps} className={trailingIconClassNames} />
                {trailingAction && <div className={styles.trailingAction}>{trailingAction}</div>}
            </div>
        </div>
    );
};
